import { Address } from "../types";

export const formatAddress = (address: Address | null) =>
  address ? `${address.streetAddress}, ${formatAddressCity(address)}` : "";

export const formatAddressCity = (address: Address) => `${address.zipCode}, ${address.city}`;
